import React from 'react'

const Manual_filtrar_clientes_grupo_id = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          ¿Cómo filtrar clientes por grupo de ID?
        </h2>
        <iframe
          src="https://scribehow.com/embed/Como_filtrar_clientes_por_grupo_de_ID__pBM6ZWKFTpmsJwtnEst7zQ?as=scrollable"
          className="scribe-iframe-general-83"
          width="100%"
          height="6700"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_filtrar_clientes_grupo_id
